<div class="jobs-bar">
  <!-- Right side: label -->
  <div class="bar-heading">
    <span class="bar-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 8h16v11H4zM9 8V6a2 2 0 012-2h2a2 2 0 012 2v2M4 13h16"/></svg>
    </span>
    <span><strong>המשרה הבאה שלכם כאן</strong><small>החליקו לצדדים וגלו הזדמנויות חדשות</small></span>
  </div>
  <!-- Scroll track -->
  @if (!loading && jobs.length) {
    <div class="scroll-track" #scrollTrack dragScroll
      aria-label="משרות מומלצות, ניתן לגרור לצדדים">
      @for (job of jobs; track job; let i = $index) {
        <button type="button"
          class="job-item"
          [class.active]="hoveredId === i"
          (mouseenter)="onHover($event, job, i)"
          (mouseleave)="onLeave()"
          (click)="navigateToPage(job.id)"
          [attr.aria-label]="'פתיחת משרה: ' + job.jobTitle"
          >
          <div class="circle" [style.border-color]="getCategoryColor(job.jobCategory?.label)">
            @if (getFirstImage(job); as imgSrc) {
              <img
                [src]="imgSrc"
                [alt]="job.jobTitle"
                class="circle-img"
                loading="lazy"
                />
            }
            @if (!getFirstImage(job)) {
              <span
                class="circle-initials"
                [style.background]="getCategoryColor(job.jobCategory?.label) + '18'"
                [style.color]="getCategoryColor(job.jobCategory?.label)"
                >
                {{ getInitials(job.companyName || job.jobTitle) }}
              </span>
            }
          </div>
          <span class="item-label">{{ getShortTitle(job) }}</span>
        </button>
      }
    </div>
  }

  <!-- Loading skeleton track -->
  @if (loading) {
    <div class="scroll-track">
      @for (i of [1,2,3,4,5,6,7,8,9,10]; track i) {
        <div class="job-item">
          <div class="circle shimmer"></div>
          <div class="label-line shimmer"></div>
        </div>
      }
    </div>
  }

  <!-- Empty -->
  @if (!loading && !error && jobs.length === 0) {
    <div class="empty-msg">אין משרות כרגע</div>
  }

  <!-- Error -->
  @if (!loading && error) {
    <div class="empty-msg error-msg">
      שגיאה בטעינה
      <span class="retry-link" (click)="fetchJobs()">נסו שוב</span>
    </div>
  }

  <!-- Left-side arrow controls -->
  @if (!loading && jobs.length) {
    <div class="scroll-arrows">
      <button class="arrow-btn" (click)="scrollRight()" aria-label="המשרות הבאות">
        ‹
      </button>
      <button class="arrow-btn" (click)="scrollLeft()" aria-label="המשרות הקודמות">
        ›
      </button>
    </div>
  }
  <button type="button" class="all-jobs" (click)="navigateToJobs()">לכל המשרות</button>
</div>

<!-- Fixed tooltip -->
@if (hoveredJob) {
  <div
    class="tip"
    [style.top.px]="tipPos.top"
    [style.left.px]="tipPos.left"
    >
    <div class="tip-arrow"></div>
    <div class="tip-title">{{ hoveredJob.jobTitle }}</div>
    @if (hoveredJob.companyName && !hoveredJob.isAnonymous) {
      <div class="tip-company">
        🏢 {{ hoveredJob.companyName }}
      </div>
    }
    @if (hoveredJob.isAnonymous) {
      <div class="tip-company">
        🏢 חברה חסויה
      </div>
    }
    <div class="tip-chips">
      @if (hoveredJob.jobCategory?.label) {
        <span class="tip-chip">
          {{ hoveredJob.jobCategory.label }}
        </span>
      }
      @if (hoveredJob.jobType?.label) {
        <span class="tip-chip">
          {{ hoveredJob.jobType.label }}
        </span>
      }
      @if (hoveredJob.workLocationType?.label) {
        <span class="tip-chip">
          {{ hoveredJob.workLocationType.label }}
        </span>
      }
    </div>
    @if (hoveredJob.city?.label || hoveredJob.region?.label) {
      <div class="tip-meta">
        📍 {{ hoveredJob.city?.label?.trim() }}
        @if (hoveredJob.region?.label) {
          <span> · {{ hoveredJob.region.label }}</span>
        }
      </div>
    }
    @if (hoveredJob.educationLevel?.label) {
      <div class="tip-meta">
        🎓 {{ hoveredJob.educationLevel.label }}
      </div>
    }
    @if (hoveredJob.skills?.label) {
      <div class="tip-meta">
        🛠 {{ hoveredJob.skills.label }}
      </div>
    }
    @if (hoveredJob.languages?.label) {
      <div class="tip-meta">
        🌐 {{ hoveredJob.languages.label }}
      </div>
    }
    @if (hoveredJob.salaryFrom) {
      <div class="tip-salary">
        {{ formatSalary(hoveredJob) }}
      </div>
    }
  </div>
}
